// @ts-check
import React, { StatelessComponent } from 'react'; // eslint-disable-line no-unused-vars
import cx from 'classnames';
import Spinner from '../Spinner';
import styles from './LoadingContent.module.scss';

/** @type { StatelessComponent<{className?: string}> } */
const LoadingContent = ({ className = '' }) => (
  <div className={cx(styles.LoadingContent, className)}>
    <div className={styles.center}>
      <Spinner />
      <div className={styles.loading_label}>Loading Content...</div>
    </div>
  </div>
);

LoadingContent.displayName = 'LoadingContent';

export default LoadingContent;
